import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserModel } from '../../models/resources/user.model';
import { normalizeListResponse, LaravelListEnvelope, NormalizedListResponse } from '../../helpers/api-envelope.helper';
import { AdminUserPayload, AdminUsersQuery } from '../../models/admin/admin-users.model';

@Injectable({
  providedIn: 'root',
})
export class AdminUsersService {
  constructor(private http: HttpClient) {}

  getUsers(query: AdminUsersQuery = {}): Observable<NormalizedListResponse<UserModel>> {
    const params: Record<string, string> = {
      paginated: String(query.paginated ?? false),
    };

    if (query.search) {
      params['search'] = query.search;
    }
    if (query.role) {
      params['role'] = query.role;
    }
    if (query.all) {
      params['all'] = '1';
    }
    if (query.active !== undefined) {
      params['active'] = query.active ? '1' : '0';
    }
    if (query.page !== undefined) {
      params['page'] = String(query.page);
    }
    if (query.perPage !== undefined) {
      params['per_page'] = String(query.perPage);
    }

    return this.http
      .get<UserModel[] | LaravelListEnvelope<UserModel>>(environment.apiUrl + '/users', { params })
      .pipe(map(normalizeListResponse));
  }

  createUser(payload: AdminUserPayload): Observable<UserModel> {
    return this.http.post<UserModel>(environment.apiUrl + '/users', payload);
  }

  updateUser(id: number, payload: AdminUserPayload): Observable<UserModel> {
    return this.http.put<UserModel>(environment.apiUrl + `/users/${id}`, payload);
  }

  deleteUser(id: number, deleteOwnedMailAccounts = false): Observable<void> {
    const params = deleteOwnedMailAccounts ? { delete_owned_mail_accounts: '1' } : undefined;
    return this.http.delete<void>(environment.apiUrl + `/users/${id}`, { params });
  }
}
